<template>
  <div>
    <div class="callback" @click="JumpBack()">
      <img src="@/assets/img/btn/back.png" alt="" />
    </div>
    <div class="header">
      <div class="nav">
        <div class="navPos">
          <div
            @click="selectCom(item)"
            v-for="(item, index) in navList"
            :key="index"
            :class="{ navlistDiv: true, active: item.show }"
          >
            <div class="titleNav">
              <img :src="item.image" alt="" />
              <div>
                {{ item.name }}
              </div>
            </div>
            <div :class="{ triangle: item.show }"></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <scenicSpot v-if="scenicSpotShow" :optionsData="selectData"></scenicSpot>
    </div>
  </div>
</template>
<script>
import scenicSpot from "./scenicSpot.vue";
export default {
  components: {
    scenicSpot,
  },
  computed: {},
  data() {
    return {
      type: "",
      navList: [
        {
          name: "景区",
          type: "1",
          image: require("@/assets/img/yygs/icoo_jq.png"),
        },
        {
          name: "酒店",
          type: "2",
          image: require("@/assets/img/yygs/icoo_jd.png"),
        },
        // {
        //   name: "活动",
        //   type: "3",
        //   image: require("@/assets/img/yygs/活动.png"),
        // },
        {
          name: "美食",
          type: "4",
          image: require("@/assets/img/yygs/icoo_ms.png"),
        },
        // {
        //   name: "城市地标",
        //   type: "5",
        //   image: require("@/assets/img/yygs/活动.png"),
        // },
      ],
      selectData: {},
      scenicSpotShow: true,
    };
  },
  created() {},
  mounted() {
    this.setNavList();
  },
  methods: {
    setNavList() {
      this.type = this.$route.query.type;
      this.scenicSpotShow = false;
      setTimeout(() => {
        this.scenicSpotShow = true;
      }, 100);
      this.navList.forEach((item) => {
        item.show = false;
      });
      let index = this.navList.findIndex((item) => item.type == this.type);
      this.navList[index].show = true;
      this.selectData = this.navList[index];
    },
    selectCom(item) {
      this.type = item.type;
      this.JumpTo("/navlist/list", { type: this.type });
    },
  },
  watch: {
    type(val, oldVal) {
      this.setNavList();
    },
  },
};
</script>
<style lang="scss" scoped>
.active {
  // color: red;
}
.header {
  height: 1.8rem;

  background: url("~@/assets/img/yygs/listbg.png") no-repeat;
  // background: pink;
  // height: 1.8rem;
  background-size: 100% 100%;
  padding: 0 0.5rem;
  box-sizing: border-box;

  .nav {
    position: relative;
    // position: absolute;
    // left: 0px;
    height: 100%;
    width: 100%;
    // background: red;

    color: white;
  }

  .navPos {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: space-around;
    bottom: 0.4rem;
    font-size: 0.35rem;
    .titleNav {
      display: flex;
      align-items: center;
      img {
        width: 0.45rem;
      }
    }
    .navlistDiv {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .triangle {
        width: 0;
        height: 0;
        border-top: 0.23rem solid #0d39bf;
        border-right: 0.23rem solid transparent;
        border-left: 0.23rem solid transparent;
        position: absolute;
        bottom: -0.6rem;
      }
    }
  }
}
</style>